import { Card } from '@bancobarigui/barihaus';
import { Statistic } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

interface KPICardProps {
  title: string;
  value: number | string;
  previousValue?: number;
  suffix?: string;
  prefix?: string;
  precision?: number;
  loading?: boolean;
}

export function KPICard({
  title,
  value,
  previousValue,
  suffix,
  prefix,
  precision = 0,
  loading = false,
}: KPICardProps) {
  const calculateTrend = () => {
    if (previousValue === undefined || previousValue === 0) return null;

    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    // Se o valor anterior for muito pequeno (quase zero), não mostrar variação
    if (Math.abs(previousValue) < 0.01) return null;

    const trend = ((numValue - previousValue) / previousValue) * 100;
    const absTrend = Math.abs(trend);

    // Limitar valores muito altos - mostrar ">999%" para variações maiores que 999%
    const displayValue = absTrend > 999 ? '>999' : absTrend.toFixed(1).replace('.', ',');
    const isExceedingMax = absTrend > 999;

    return {
      value: displayValue,
      isPositive: trend > 0,
      isExceedingMax,
    };
  };

  const trend = calculateTrend();

  return (
    <Card bordered={false} loading={loading} style={{ height: '100%' }}>
      <Statistic
        title={title}
        value={value}
        precision={precision}
        suffix={suffix}
        prefix={prefix}
        valueStyle={{ color: '#262626' }}
      />
      {trend && (
        <div style={{ marginTop: '8px', fontSize: '14px' }}>
          {trend.isPositive ? (
            <span style={{ color: '#52c41a' }}>
              <ArrowUpOutlined /> {trend.value}%
            </span>
          ) : (
            <span style={{ color: '#ff4d4f' }}>
              <ArrowDownOutlined /> {trend.value}%
            </span>
          )}
          <span style={{ marginLeft: '8px', color: '#8c8c8c' }}>vs. período anterior</span>
        </div>
      )}
    </Card>
  );
}
